import apiClient from '../apiClient';
import { GET_SPECIAL_ADJUSMENT_BY_TRANSACTION_ID_URL } from '../apiUrl';

const getSpecialAdjusmentByTransactionIdApi = Id => {
  return apiClient.get(GET_SPECIAL_ADJUSMENT_BY_TRANSACTION_ID_URL(Id));
};

export default getSpecialAdjusmentByTransactionIdApi;
